var path = 'src/app/posts/post-list.html';
var html = "<div page-wrapper> <h1 class=page-header>News</h1> <p create-post-permission> <a ui-sref=createPost class=\"btn btn-primary\">New Post</a> </p> <div loading=loading list-helper=proxy> <div ng-show=!items.length> <p>No posts found.</p> </div> <div ng-repeat=\"post in items\" class=post> <h2><a ui-sref=\"post({postId: post.id})\">{{post.title}}</a> <small>{{post.publishedDate | dateFormat}}</small></h2> <div ng-bind-html=\"post.body | unsafe\"></div> </div> <div pagination-helper></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/posts/post-list.html
 ** module id = 640
 ** module chunks = 0
 **/